import React from "react";
import { Redirect, Route } from "react-router-dom";
import jwt_decode from "jwt-decode";

const isAdminAuthenticated = () => {
  const token = localStorage.getItem("adminToken");
  if (!token) return false;
  try {
    const decoded = jwt_decode(token);
    // Only reject when an exp claim exists AND has passed. Tokens without an
    // exp claim are treated as valid.
    if (decoded.exp && decoded.exp <= Date.now() / 1000) return false;
    return true;
  } catch {
    return false;
  }
};

const AdminPrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAdminAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to="/admin/login" />
      )
    }
  />
);

export default AdminPrivateRoute;
